import blurImage from "./images/blurImage.jpg";
import { IoDownloadOutline } from "react-icons/io5";
import { api } from "../../../../../api";
import { Link } from "react-router-dom";
import { PddDocument } from "../../../../../types";

interface ProjectDesignDocumentsAllCardProps {
  projectDetails: PddDocument;
  downloadable?: boolean;
}

const ProjectDesignDocumentsAllTabCard = ({
  projectDetails,
  downloadable,
}: ProjectDesignDocumentsAllCardProps) => {
  // function to split the document create date and time
  const separateDateAndTime = (createdAt: string) => {
    const [date, timeWithMilliseconds] = createdAt.split("T");
    const time = timeWithMilliseconds.split(".")[0];
    return { date, time };
  };

  const handleDownloadPDF = async () => {
    const downloadResponse = await api.get(`/documents/export/${projectDetails?.id}`, {
      responseType: "blob",
    });

    const pdfBlob = new Blob([downloadResponse?.data], { type: "application/pdf" });

    // create a temp url for the Blob
    const url = window.URL.createObjectURL(pdfBlob);

    const tempLink = document.createElement("a");
    tempLink.href = url;
    tempLink.setAttribute("download", `pdd_${new Date()}.pdf`);

    document.body.appendChild(tempLink);
    tempLink.click();

    // clean up the temporary elements and URL
    document.body.removeChild(tempLink);
    window.URL.revokeObjectURL(url);
  };

  return (
    <div>
      <div className="cursor-pointer space-y-3 rounded-md bg-white px-4 py-2 shadow-sm">
        {/* Project title and ID */}
        <div className="flex items-start gap-4">
          {/* <Link to={`/Project-Design-Document/Add-New-PDD?pddID=${projectDetails?.id}`}> */}
          <Link
            to={`/Project-Design-Document/Add-New-PDD?pddID=${projectDetails?.id}`}
            className="flex-1 text-lg font-medium text-primaryPurple-100"
          >
            <span>
              {projectDetails?.name}
              <span className="font-normal text-gray-500"> | ID: 4837</span>
            </span>
          </Link>
          {downloadable && (
            <IoDownloadOutline
              className="rounded-sm text-xl hover:cursor-pointer hover:text-primaryPurple-200"
              onClick={handleDownloadPDF}
            />
          )}
        </div>

        {/* Project Image and badge */}
        <div className="relative">
          <img src={blurImage} alt="project image" className="rounded-sm" />
          <div
            className={`text-black" absolute right-3 top-3 rounded-md px-3 py-1 text-sm font-medium ${
              projectDetails?.status === "Under Vallidation" ? "bg-[#81BD5B33]" : "bg-[#FF6C3733]"
            }`}
          >
            {projectDetails?.status}
          </div>
        </div>

        {/* project details */}
        <div className="flex justify-between">
          <div>
            <span className="text-sm font-medium text-gray-600">Created On</span>
            <p className="text-sm font-medium text-black">
              {separateDateAndTime(projectDetails?.created_at).date} |{" "}
              {separateDateAndTime(projectDetails?.created_at).time}
            </p>
          </div>
          <div>
            <span className="text-sm font-medium text-gray-600">Project Type</span>
            <p className="text-sm font-medium text-black">{projectDetails?.status}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectDesignDocumentsAllTabCard;
